module.exports = __webpack_public_path__ + "img/grooming4.03bf8bfb.jpg";